import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'privacy';

const setPrivacy = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "set_privacy" , data: params}, callback);

const apiEndpoint = {
  setPrivacy,
}

export default apiEndpoint;